/* eslint-disable @typescript-eslint/no-explicit-any */
import { SupabaseClient } from '@supabase/supabase-js';

import { Database, withLogs } from '@core';

import { ResponseWithCount } from '../responses';

import { mapSwing, Swing, SWING_QUERY } from './swing';

export type FavoriteSwing = Swing;

type FetchFavoriteSwingOptions = { userId: string; from: number; to: number; nameFilter?: string };

const mapFavoriteSwings = (data: any): FavoriteSwing[] => {
    return data.map(mapSwing);
};

// TODO rethink clubs and tags
export const fetchFavoriteSwings = withLogs(
    async (
        supabase: SupabaseClient<Database>,
        { userId, from, to, nameFilter }: FetchFavoriteSwingOptions,
    ): Promise<ResponseWithCount<FavoriteSwing[]>> => {
        let query = supabase
            .from('swings')
            .select(
                SWING_QUERY,
                // Built-in supabase row count
                { count: 'exact' },
            )
            .order('created_at', { ascending: false })
            .eq('favorite', true)
            .eq('deleted', false)
            // `swing.user_id` can often be null, so we depend on `activities.user_id` instead
            .eq('activities.user_id', userId)
            // Supabase uses inclusive range [from, to] instead of the usual [from, to)
            // So .range(0, 9) will return 10 rows (including index 9)
            // this is why we need to subtract -1 from to.
            .range(from, to - 1);

        if (nameFilter) {
            query = query.ilike('name', `%${nameFilter}%`);
        }

        const { data: swings, error, count } = await query;

        if (error) {
            throw error;
        }

        return { data: mapFavoriteSwings(swings), count };
    },
    'fetchFavoriteSwings',
);
